var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "product-insights" },
    [
      _c(
        "carousel",
        {
          attrs: { "per-page": 4, navigationEnabled: true, "mouse-drag": false }
        },
        [
          _c("slide", [
            _c("div", { staticClass: "metrics-box" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-8" }, [
                  _c("h3", [_vm._v("Lead Conversion Rate:")]),
                  _c("h2", [_vm._v(_vm._s(_vm.leadConversionRateNumber))])
                ]),
                _c("div", { staticClass: "col-md-4" }, [
                  _c("h5", { staticClass: "brown_line" }, [
                    _vm._v(_vm._s(_vm.leadConversionRate) + "%")
                  ])
                ])
              ])
            ])
          ]),
          _c("slide", [
            _c("div", { staticClass: "metrics-box" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-8" }, [
                  _c("h3", [_vm._v("Sales Conversion Rate:")]),
                  _c("h2", [_vm._v(_vm._s(_vm.SalesConversionRateNumber))])
                ]),
                _c("div", { staticClass: "col-md-4" }, [
                  _c("h5", [_vm._v(_vm._s(_vm.SalesConversionRate) + "%")])
                ])
              ])
            ])
          ]),
          _c("slide", [
            _c("div", { staticClass: "metrics-box" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-8" }, [
                  _c("h3", [_vm._v("Retention Rate:")]),
                  _c("h2", [_vm._v(_vm._s(_vm.retentionRateNumber))])
                ]),
                _c("div", { staticClass: "col-md-4" }, [
                  _c("h5", { staticClass: "brown_line" }, [
                    _vm._v(_vm._s(_vm.retentionRate) + "%")
                  ])
                ])
              ])
            ])
          ]),
          _c("slide", [
            _c("div", { staticClass: "metrics-box" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-8" }, [
                  _c("h3", [_vm._v("Upsell Ratio:")]),
                  _c("h2", [_vm._v(_vm._s(_vm.upsellRatioNumber))])
                ]),
                _c("div", { staticClass: "col-md-4" }, [
                  _c("h5", [_vm._v(_vm._s(_vm.upsellRatio) + "%")])
                ])
              ])
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }